/**
 * <s-scroll-jump> is a floating button that jumps to the bottom of the page,
 * then flips to jump back to the top once the visitor has scrolled down.
 */
class SScrollJump extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.downLabel = this.dataset.downLabel || '';
    this.upLabel = this.dataset.upLabel || '';
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.ticking = false;

    this.onScroll = () => {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    };
    this.onClick = () => {
      const behavior = this.reduceMotion ? 'auto' : 'smooth';
      const top = this.mode === 'up' ? 0 : document.documentElement.scrollHeight;
      window.scrollTo({ top, behavior });
    };

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    window.addEventListener('load', this.onScroll);
    if (this.button) this.button.addEventListener('click', this.onClick);
    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
    window.removeEventListener('load', this.onScroll);
    if (this.button) this.button.removeEventListener('click', this.onClick);
  }

  update() {
    const doc = document.documentElement;
    const maxScroll = doc.scrollHeight - window.innerHeight;
    const progress = maxScroll > 0 ? window.scrollY / maxScroll : 0;
    // Hide on short pages where there is nothing to jump to.
    this.toggleAttribute('data-short', maxScroll < window.innerHeight * 0.8);
    const mode = progress > 0.35 ? 'up' : 'down';
    this.style.setProperty('--scroll-progress', String(Math.min(1, Math.max(0, progress))));
    if (mode === this.mode) return;
    this.mode = mode;
    this.dataset.mode = mode;
    if (this.button) this.button.setAttribute('aria-label', mode === 'up' ? this.upLabel : this.downLabel);
  }
}

if (!customElements.get('s-scroll-jump')) customElements.define('s-scroll-jump', SScrollJump);
